import { useState } from "react";
import api from "@/lib/api";

function errText(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    if (d.some(x => (x.loc || []).includes("temporary_password"))) return "Temporary password must be at least 6 characters.";
    return "Please check both passwords and try again.";
  }
  return e?.response ? `Request failed (${e.response.status}). Please try again.` : "Couldn't reach the Hub. Check your connection and try again.";
}

// One dialog: temp password for the worker + the Admin's own password to confirm.
export default function SetPasswordModal({ target, onClose }) {
  const creating = !!target.wid;
  const [pw, setPw] = useState("");
  const [adminPw, setAdminPw] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) { setErr("Temporary password must be at least 6 characters."); return; }
    if (!adminPw) { setErr("Enter your own Admin password to confirm."); return; }
    setBusy(true);
    try {
      if (creating) await api.post(`/auth/workers/${target.wid}/create-login`, { temporary_password: pw, current_password: adminPw });
      else await api.post(`/auth/users/${target.uid}/password-reset`, { temporary_password: pw, current_password: adminPw });
      setOk(creating
        ? `Login created for ${target.name}. They'll be asked to choose a new password at first login.`
        : `Password reset for ${target.name}. They'll be asked to change it at next login.`);
    } catch (e2) { setErr(errText(e2)); }
    finally { setBusy(false); }
  }

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" data-testid="set-password-modal">
      <form onSubmit={submit} className="card max-w-md w-full space-y-3">
        <h3 className="text-silver">{creating ? `Create login — ${target.name}` : `Reset password — ${target.name}`}</h3>
        {ok ? (
          <>
            <div className="text-sm text-green-400" data-testid="set-password-ok">{ok}</div>
            <div className="flex justify-end"><button type="button" className="btn-silver" onClick={() => onClose(true)} data-testid="set-password-done">Done</button></div>
          </>
        ) : (
          <>
            <label className="block text-sm text-silver">Temporary password for {target.name} (min 6 characters)
              <div className="relative">
                <input className="input pr-14" type={show ? "text" : "password"} autoComplete="new-password" autoFocus
                       value={pw} onChange={e => setPw(e.target.value)} data-testid="pw-reset-input" />
                <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-silver" onClick={() => setShow(s => !s)} data-testid="pw-reset-toggle">{show ? "Hide" : "Show"}</button>
              </div>
            </label>
            <label className="block text-sm text-silver">Your Admin password (to confirm)
              <input className="input" type="password" autoComplete="current-password" value={adminPw} onChange={e => setAdminPw(e.target.value)} data-testid="reauth-pw" />
            </label>
            {err && <div className="text-sm text-red-400" role="alert" data-testid="set-password-error">{err}</div>}
            <div className="flex gap-2 justify-end">
              <button type="button" className="btn-ghost" onClick={() => onClose(false)} data-testid="set-password-cancel">Cancel</button>
              <button className="btn-silver" disabled={busy} data-testid="btn-admin-reset-pw">{busy ? "Saving…" : creating ? "Create login" : "Reset password"}</button>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
